import * as api from "../api/index.js";

export const FETCH_WORKFLOW_DEFINITIONS = "FETCH_WORKFLOW_DEFINITIONS";
export const FETCH_WORKFLOW_DEFINITION = "FETCH_WORKFLOW_DEFINITION";
export const CREATE_WORKFLOW_DEFINITION = "CREATE_WORKFLOW_DEFINITION";
export const UPDATE_WORKFLOW_DEFINITION = "UPDATE_WORKFLOW_DEFINITION";
export const DELETE_WORKFLOW_DEFINITION = "DELETE_WORKFLOW_DEFINITION";
export const TOGGLE_WORKFLOW_DEFINITION = "TOGGLE_WORKFLOW_DEFINITION";

export const LAUNCH_WORKFLOW_INSTANCE = "LAUNCH_WORKFLOW_INSTANCE";
export const FETCH_WORKFLOW_INSTANCE = "FETCH_WORKFLOW_INSTANCE";
export const FETCH_WORKFLOW_ENTITY_INSTANCES = "FETCH_WORKFLOW_ENTITY_INSTANCES";
export const FETCH_WORKFLOW_INBOX = "FETCH_WORKFLOW_INBOX";
export const WORKFLOW_APPROVE_STEP = "WORKFLOW_APPROVE_STEP";
export const WORKFLOW_REJECT_STEP = "WORKFLOW_REJECT_STEP";
export const WORKFLOW_ADD_COMMENT = "WORKFLOW_ADD_COMMENT";
export const RECALL_WORKFLOW_INSTANCE = "RECALL_WORKFLOW_INSTANCE";
export const CANCEL_WORKFLOW_INSTANCE = "CANCEL_WORKFLOW_INSTANCE";
export const FETCH_WORKFLOW_AUDIT = "FETCH_WORKFLOW_AUDIT";
export const WORKFLOW_LOADING = "WORKFLOW_LOADING";
export const WORKFLOW_ERROR = "WORKFLOW_ERROR";

const dispatch_ok = (dispatch, type, data) => dispatch({ type, payload: data });

export const fetchWorkflowDefinitions = (openSnackbar) => async (dispatch) => {
  try {
    dispatch({ type: WORKFLOW_LOADING });
    const { data } = await api.fetchWorkflowDefinitions();
    dispatch_ok(dispatch, FETCH_WORKFLOW_DEFINITIONS, data.data);
  } catch (err) {
    dispatch({ type: WORKFLOW_ERROR, payload: err.message });
    openSnackbar?.(err.response?.data?.message || err.message, "error");
  }
};

export const createWorkflowDefinition = (formData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.createWorkflowDefinition(formData);
    dispatch_ok(dispatch, CREATE_WORKFLOW_DEFINITION, data.data);
    openSnackbar?.("Workflow created successfully", "success");
    return data.data;
  } catch (err) {
    openSnackbar?.(err.response?.data?.message || err.message, "error");
    return null;
  }
};

export const updateWorkflowDefinition = (id, formData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateWorkflowDefinition(id, formData);
    dispatch_ok(dispatch, UPDATE_WORKFLOW_DEFINITION, data.data);
    openSnackbar?.("Workflow updated successfully", "success");
    return data.data;
  } catch (err) {
    openSnackbar?.(err.response?.data?.message || err.message, "error");
    return null;
  }
};

export const deleteWorkflowDefinition = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteWorkflowDefinition(id);
    dispatch_ok(dispatch, DELETE_WORKFLOW_DEFINITION, id);
    openSnackbar?.("Workflow deleted", "success");
  } catch (err) {
    openSnackbar?.(err.response?.data?.message || err.message, "error");
  }
};

export const toggleWorkflowDefinition = (id, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.toggleWorkflowDefinition(id);
    dispatch_ok(dispatch, TOGGLE_WORKFLOW_DEFINITION, data.data);
  } catch (err) {
    openSnackbar?.(err.response?.data?.message || err.message, "error");
  }
};

export const launchWorkflowInstance = (payload, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.launchWorkflowInstance(payload);
    dispatch_ok(dispatch, LAUNCH_WORKFLOW_INSTANCE, data.data);
    openSnackbar?.("Workflow submitted for approval", "success");
    return data.data;
  } catch (err) {
    openSnackbar?.(err.response?.data?.message || err.message, "error");
    return null;
  }
};

export const fetchWorkflowInstancesForEntity = (entityType, entityId) => async (dispatch) => {
  try {
    const { data } = await api.fetchWorkflowInstancesForEntity(entityType, entityId);
    dispatch({
      type: FETCH_WORKFLOW_ENTITY_INSTANCES,
      payload: { key: `${entityType}:${entityId}`, instances: data.data },
    });
  } catch (err) {
    dispatch({ type: WORKFLOW_ERROR, payload: err.message });
  }
};

export const fetchWorkflowInbox = () => async (dispatch) => {
  try {
    dispatch({ type: WORKFLOW_LOADING });
    const { data } = await api.fetchWorkflowInbox();
    dispatch_ok(dispatch, FETCH_WORKFLOW_INBOX, data.data);
  } catch (err) {
    dispatch({ type: WORKFLOW_ERROR, payload: err.message });
  }
};

export const approveWorkflowStep = (instanceId, formData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.approveWorkflowStep(instanceId, formData);
    dispatch_ok(dispatch, WORKFLOW_APPROVE_STEP, data.data);
    openSnackbar?.("Step approved", "success");
    return data.data;
  } catch (err) {
    openSnackbar?.(err.response?.data?.message || err.message, "error");
    return null;
  }
};

export const rejectWorkflowStep = (instanceId, formData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.rejectWorkflowStep(instanceId, formData);
    dispatch_ok(dispatch, WORKFLOW_REJECT_STEP, data.data);
    openSnackbar?.("Step rejected", "success");
    return data.data;
  } catch (err) {
    openSnackbar?.(err.response?.data?.message || err.message, "error");
    return null;
  }
};

export const addWorkflowComment = (instanceId, formData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.addWorkflowComment(instanceId, formData);
    dispatch_ok(dispatch, WORKFLOW_ADD_COMMENT, data.data);
    openSnackbar?.("Comment added", "success");
    return data.data;
  } catch (err) {
    openSnackbar?.(err.response?.data?.message || err.message, "error");
    return null;
  }
};

export const recallWorkflowInstance = (id, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.recallWorkflowInstance(id);
    dispatch_ok(dispatch, RECALL_WORKFLOW_INSTANCE, data.data);
    openSnackbar?.("Workflow recalled", "success");
  } catch (err) {
    openSnackbar?.(err.response?.data?.message || err.message, "error");
  }
};

export const cancelWorkflowInstance = (id, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.cancelWorkflowInstance(id);
    dispatch_ok(dispatch, CANCEL_WORKFLOW_INSTANCE, data.data);
    openSnackbar?.("Workflow cancelled", "success");
  } catch (err) {
    openSnackbar?.(err.response?.data?.message || err.message, "error");
  }
};
